import axios from 'axios';

export default {
  getApiV3Url() {
    return process.env.VUE_APP_API_V3_BASE_URL;
  },
  /**
   * Returns the response from the api
   * @param {string} url
   * @param {Object} body
   * @returns {SendPushesResponse} response from the fcm server.
   */
  async post(url, body) {
    try {
      return await axios.post(url, body,);
    } catch (e) {
      console.log(e);
    }
  },
}
